// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"703":"fcd28446","782":"0da07cc8"}[chunkId] + ".chunk.js";
};